// Package Imports
import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';

// Project Imports
import routeName from 'core/common/routeName';
import resourceName from 'core/common/resourceName';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';
// Lazy-loaded Component
const OrgAccessControl = lazy(
  () => import('pages/orgAccessControl/orgAccessControl')
);

const OrgAccessControlRoute = (
  <Route
    path={routeName.orgAccessControl}
    element={
      <PrivateRoute name={resourceName.orgAccessControl}>
        <Suspense fallback={<Loading />}>
          <OrgAccessControl />
        </Suspense>
      </PrivateRoute>
    }
  />
);

export default OrgAccessControlRoute;
